import PropTypes from 'prop-types';

import Button from '#globalComponents/Button/Button';
import Panel from '#globalComponents/Overlay/Panel';
import { formatDate } from '#lib/dateUtils';

import PauseTeaserCard from '../components/PauseTeaserCard';

// Cancelling ends the subscription at the period end, which supersedes a scheduled or running pause.
function buildPauseFact(pause, isPaused) {
	if (!pause) return null;
	if (!isPaused) return `Ihre geplante Pause ab dem ${formatDate(pause.startsAt)} entfällt damit.`;
	return pause.resumesAt ? `Die automatische Fortsetzung am ${formatDate(pause.resumesAt)} entfällt damit.` : null;
}

export default function ConfirmCancelStep({
	currentPeriodEnd,
	pendingPlanName,
	pause = null,
	isPaused = false,
	onKeep,
	onConfirm,
	onPause,
	isLoading = false,
	onClose,
}) {
	const endText = currentPeriodEnd
		? `am ${formatDate(currentPeriodEnd)}`
		: 'zum Ende der aktuellen Abrechnungsperiode';
	const untilThenText = isPaused
		? 'Bis dahin bleiben Ihre Daten wie während der Pause sichtbar; Lead-Recherche, Versand und Export bleiben deaktiviert.'
		: 'Bis dahin können Sie B2B Hero uneingeschränkt weiternutzen.';
	const facts = [
		'Ihre Daten bleiben erhalten – Leads, Kampagnen und CRM gehen nicht verloren.',
		'Sie können die Kündigung bis dahin jederzeit in den Abo-Einstellungen zurücknehmen.',
		buildPauseFact(pause, isPaused),
		pendingPlanName ? `Ihr geplanter Wechsel auf „${pendingPlanName}“ wird damit aufgehoben.` : null,
	].filter(Boolean);

	return (
		<>
			<Panel.Header onClose={onClose}>Kündigung bestätigen</Panel.Header>

			<Panel.Body>
				<div className="space-y-5">
					<p className="text-sm text-text">
						Ihr Abonnement endet {endText}. {untilThenText}
					</p>

					<ul className="list-disc pl-5 space-y-1.5 text-sm text-text">
						{facts.map((fact) => (
							<li key={fact}>{fact}</li>
						))}
					</ul>

					{onPause && (
						<PauseTeaserCard
							title="Lieber pausieren statt kündigen?"
							onClick={onPause}
							disabled={isLoading}
						/>
					)}
				</div>
			</Panel.Body>

			<Panel.Footer>
				<div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
					<Button variant="outline" size="md" fullWidth onClick={onKeep} disabled={isLoading}>
						Abonnement behalten
					</Button>
					<Button variant="danger" size="md" fullWidth loading={isLoading} onClick={onConfirm}>
						Jetzt kündigen
					</Button>
				</div>
			</Panel.Footer>
		</>
	);
}

ConfirmCancelStep.propTypes = {
	currentPeriodEnd: PropTypes.string,
	pendingPlanName: PropTypes.string,
	pause: PropTypes.shape({
		startsAt: PropTypes.string.isRequired,
		resumesAt: PropTypes.string,
	}),
	isPaused: PropTypes.bool,
	onKeep: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	onPause: PropTypes.func,
	isLoading: PropTypes.bool,
	onClose: PropTypes.func,
};
